import { Component, Inject, OnInit } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from "ng-zorro-antd/modal";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastService } from '../../../core/services/toast.service';
import { DpfService } from "../../../core/services/dpf.service";
import { firstValueFrom } from "rxjs";
import { TranslateService } from '@ngx-translate/core';

/**
 * @deprecated This component is deprecated. Use FeedbackComponent instead.
 * @see FeedbackComponent
 */
@Component({
    selector: 'app-contact-modal',
    templateUrl: './contact-modal.component.html',
    styleUrls: ['./contact-modal.component.scss']
})
export class ContactModalComponent implements OnInit {
    contactForm!: FormGroup;
    propMap: { [n: string]: any } = {
        //     'name': {
        //         label: 'Name',
        //         placeholder: 'Your Full Name',
        //         maxLength: 252,
        //         required: true,
        //     },
        'firstName': {
            label: 'First Name',
            placeholder: 'Your First Name',
            maxLength: 252,
            required: true,
        },
        'lastName': {
            label: 'Last Name',
            placeholder: 'Your Last Name',
            maxLength: 252,
            required: true,
        },
        'organizationName': {
            label: 'Organization / Company',
            placeholder: 'Your Company Name (optional)',
            maxLength: 252,
            required: true,
        },
        'emailAddress': {
            label: 'Email Address',
            placeholder: 'Your Email Address',
            maxLength: 252,
            email: true,
            required: true,
        },
        'receivingUpdates': {
            label: 'Receive the latest updates',
            type: 'checkbox',
            value: true
        },
        'phoneNumber': {
            label: 'Phone Number',
            placeholder: 'Your Phone Number (optional)',
            maxLength: 252,
            phone: true,
        },
        'reasonForContact': {
            label: 'Reason for Contact',
            placeholder: 'Choose one',
            type: 'select',
            options: [
                {
                    value: 'Inquiry about DataCore datasets & services',
                    label: 'Inquiry about DataCore datasets & services'
                },
                { value: 'Request a demo or trial access', label: 'Request a demo or trial access' },
                { value: 'Partnership opportunities', label: 'Partnership opportunities' },
                { value: 'API integration support', label: 'API integration support' },
                { value: 'Technical support', label: 'Technical support' },
            ],
            hasOtherOption: true,

        },
        'message': {
            label: 'Message',
            placeholder: 'Write your message here... (The more details you provide, the better we can assist you!)',
            type: 'textarea',
            maxLength: 2000,
        },
    }
    loading = false;

    constructor(
        private modal: NzModalRef,
        @Inject(NZ_MODAL_DATA) public data: any,
        private fb: FormBuilder,
        private toast: ToastService,
        private dpfService: DpfService,
        private translate: TranslateService
    ) {
    }

    ngOnInit() {
        this.initForm();
    }

    initForm() {
        this.contactForm = this.fb.group(
            Object.keys(this.propMap).reduce((acc, key) => {
                const validators = [Validators.maxLength(this.propMap[key]?.maxLength)];
                if (this.propMap[key]?.email) {
                    validators.push(Validators.email);
                }
                if (this.propMap[key]?.phone) {
                    validators.push(Validators.pattern(/^\+?[0-9]{8,15}$/));
                }

                if (this.propMap[key]?.required) {
                    validators.push(Validators.required);
                }
                acc[key] = this.fb.control(this.propMap[key]?.value ?? '', validators);
                return acc;
            }, {} as { [key: string]: any })
        );
    }

    async submitForm() {
        const req = this.contactForm.value;
        this.loading = true;
        const res: any = await firstValueFrom(this.dpfService.submitGeneralInquiry(req));
        if (!res?.status) {
            const errorMsg = this.translate.instant('notifications.form.submitError');
            this.toast.error(errorMsg);
            this.loading = false;
            return;
        }
        const successMsg = this.translate.instant('notifications.form.submitSuccess');
        this.toast.success(successMsg);
        this.loading = false;
    }

    objectKeys(obj: any): string[] {
        return Object.keys(obj);
    }

    getErrorMessage(controlName: string) {
        const control = this.contactForm.controls[controlName];

        if (!control || !control.validator) {
            return '';
        }

        if (control.hasError('required')) {
            return `${this.propMap[controlName].label} is required.`;
        }
        if (control.hasError('pattern')) {
            return `${this.propMap[controlName].label} is invalid.`;
        }
        if (control.hasError('maxlength')) {
            return `${this.propMap[controlName].label} must be at most ${this.propMap[controlName].maxLength} characters.`;
        }
        if (control.hasError('email')) {
            return `${this.propMap[controlName].label} must be a valid email address.`;
        }
        return '';
    }

    close(): void {
        this.modal.destroy();
    }
}
